var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('head-card',[_c('buyRuleMod')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }